import LoadingSpinner from './LoadingSpinner.jsx';

export default function KpiCard({ label, value, sub, icon: Icon, accentClass = '', loading = false }) {
  return (
    <div className="rounded-xl bg-white border border-slate-200 shadow-sm px-4 py-4 flex flex-col gap-2">
      <div className="flex items-center justify-between">
        <span className="text-xs font-medium text-slate-500 uppercase tracking-wide">{label}</span>
        {Icon && <Icon size={16} className="text-slate-400" aria-hidden />}
      </div>
      {loading ? (
        <LoadingSpinner size="sm" className="my-1" />
      ) : (
        <p className={`text-2xl font-bold tabular-nums ${accentClass || 'text-slate-900'}`}>
          {value ?? '—'}
        </p>
      )}
      {sub && <p className="text-xs text-slate-500">{sub}</p>}
    </div>
  );
}
